import React from "react";
import { Row, Col, Button, Form, Checkbox, Steps } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import "./Application7.css";
import "../components/StepsTracker.css";

const Application7: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const handleNext = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Form values:", values);
        // Navigate to next step (Terms & Conditions)
        navigate("/application8");
      })
      .catch((errorInfo) => {
        console.log("Validation failed:", errorInfo);
      });
  };

  return (
    <div className="application-step-container">
      <div className="application-title-card">
        <div className="title-card-content">
          <div className="city-name-title">City of New Orleans, Louisiana</div>
          <h1 className="program-title-main">E-Bike Incentive Application</h1>
        </div>
      </div>

      <div className="progress-tracker-container">
        <Steps
          current={6}
          className="progress-tracker-steps"
          items={[
            { title: "Review Eligibility" },
            { title: "Confirm Details" },
            { title: "Personal Information" },
            { title: "Upload Documents" },
            { title: "Income Verification" },
            { title: "Survey" },
            { title: "Future Communications" },
            { title: "Terms & Conditions" },
          ]}
        />
      </div>

      <div className="main-step-card">
        <div className="step-header-container">
          <div className="step-badge">
            <div className="step-label">STEP</div>
            <div className="step-number">7</div>
          </div>
          <div className="step-content-info">
            <h2 className="step-title">Future Communications</h2>
          </div>
        </div>

        <div className="step-divider" />

        <div className="communications-section">
          <Form form={form} layout="vertical" className="communications-form">
            {/* Required participation section */}
            <div className="communication-section">
              <h3 className="communication-section-title">
                Required participation in additional program survey
              </h3>
              <p className="communication-section-description">
                As a part of this program, incentive recipients{" "}
                <span className="bold-text">
                  must be willing to provide feedback through a short survey
                </span>{" "}
                that will be sent to you via email within 30-60 days of program
                acceptance.
              </p>

              <Form.Item name="requiredSurvey" className="checkbox-form-item">
                <Checkbox
                  value="understand-required-survey"
                  className="communications-checkbox"
                >
                  I understand that I will be asked about my experience riding
                  an e-bike in New Orleans and purchasing an e-bike through the
                  pilot program{" "}
                  <span className="bold-text">via a short survey.</span>
                </Checkbox>
              </Form.Item>
            </div>

            <div className="communication-divider" />

            {/* Optional in-depth survey section */}
            <div className="communication-section">
              <h3 className="communication-section-title">
                Optional in-depth program survey
              </h3>
              <p className="communication-section-description">
                We may also invite a select few to participate in more in-depth
                feedback. Those who participate in more in-depth feedback will
                be compensated for their time.
              </p>

              <Form.Item name="optionalSurvey" className="checkbox-form-item">
                <Checkbox
                  value="understand-optional-survey"
                  className="communications-checkbox"
                >
                  I understand that I may be asked to share feedback about my
                  experience riding an e-bike in New Orleans and purchasing an
                  e-bike through the pilot program{" "}
                  <span className="bold-text">
                    via an interview, on-site observation, or other more
                    in-depth format.
                  </span>
                </Checkbox>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>

      <div className="navigation-buttons">
        <Link to="/application6">
          <Button
            type="default"
            icon={<ArrowLeftOutlined />}
            className="back-button"
          >
            Back
          </Button>
        </Link>
        <Button
          type="primary"
          className="next-button"
          size="large"
          onClick={handleNext}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default Application7;
